import { AdminPanelSection } from "../Interfaces"

const RegisterAdminPage = (details: AdminPanelSection) => {
    return details
}

export default RegisterAdminPage